import { scrollTo } from "@/js/animation.js";
export default {
  name: "TermsOfSales",
  mounted: function mounted() {
    var _this$$route$hash,
      _this = this;
    if (((_this$$route$hash = this.$route.hash) === null || _this$$route$hash === void 0 ? void 0 : _this$$route$hash.length) > 0) {
      this.$nextTick(function () {
        scrollTo(_this.$route.hash);
      });
    }
  }
};